import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Button, Grid, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { fetchGroupsList } from "./groupThunks";
import GroupList from "./components/GroupList";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const Groups = () => {
  const dispatch = useDispatch();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { groups } = useSelector((state) => state.groups);

  const navigate = useNavigate();
  const handleNavigateToBack = () => {
    navigate("/inventory/dashboard");
  };

  useEffect(() => {
    dispatch(fetchGroupsList());
  }, [dispatch]);

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <Button
          type="text"
          icon={
            <ArrowLeftOutlined
              style={{ fontSize: !screens.md ? "18px" : "22px" }}
            />
          } // ✅ Scaled to match Title
          onClick={handleNavigateToBack}
          style={{
            marginRight: 12,
            padding: 0,
            height: "auto",
            lineHeight: "1",
            color: "#000", // optional, keeps consistent with text color
          }}
        />
        <Title
          level={!screens.md ? 4 : 2}
          style={{
            margin: 0,
            whiteSpace: "normal",
            wordBreak: "break-word",
            textAlign: !screens.md ? "center" : "left",
          }}
        >
          Item Group Manage
        </Title>
      </div>
      <GroupList groupsList={groups} />
    </>
  );
};

export default Groups;
